/**
 * Shared constants for use across packages
 */

// Theme storage key
export const STORAGE_KEYS = {
  THEME_MODE: "rusha:theme_mode",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
